import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Row, Col, Card, Checkbox, Skeleton, Pagination, Typography } from 'antd';
import FilterPanel from '../../components/common/filterPanel';
import { getPrjFilterSectionData, searchProjects, searchProjectsCount } from '../../services/projectService';
import ProjectDataTable from '../../components/projects/projectsDataTable';
import { convertSelFilterValToLuObj, convertSelFilterValBusinessToLuObj, formatDate, convertSelProjectType, getClientList } from '../../utils/commonUtil';
import ProjectCard from '../../components/projects/projectCard';
import { useDispatch, useSelector } from 'react-redux';
import { setKeywordSearchStr } from '../../context/reducers/userReducer';
import ProjectExcelDownload from '../../components/projects/projectExcelDownload';
import { useNavigate } from 'react-router-dom';
import FloatingOptions from "../../components/common/floatingOptions";
import commonService from "../../services/CommonService";
import { UserActivity } from "../../config/BVConstants";
export const Projects = () => {
    var _a, _b, _c, _d;
    const [selBrandList, setSelBrandList] = useState([]);
    const [selProjectType, setSelProjectType] = useState([]);
    const [selCountryTerritoryList, setSelCountryTerritoryList] = useState([]);
    const [selProductTypeList, setSelProductTypeList] = useState([]);
    const [selServiceTypeList, setSelServiceTypeList] = useState([]);
    const [selLstBVLocation, setSelLstBVLocation] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);
    const [selRecommendedStartDate, setSelRecommendedStartDate] = useState([undefined, undefined]);
    const [selPlanedCompletionDate, setSelPlanedCompletionDate] = useState([undefined, undefined]);
    const [selActualCompletionDate, setSelActualCompletionDate] = useState([undefined, undefined]);
    const [prjDataList, setPrjDataList] = useState();
    const [strSearchBoxText, setStrSearchBoxText] = useState();
    const [boolCardView, setBoolCardView] = useState(false);
    const applicationData = useSelector((state) => state.applicationData); //useApplicationContext();
    const dispatch = useDispatch();
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const showLinkParam = urlParams.get('key');
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0
    });
    const [searchPrjRequest, setSearchPrjRequest] = useState();
    const [width, setWidth] = useState(window.innerWidth);
    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }
    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        };
    }, []);
    let lstProject = [];
    let intRstatus = urlParams.get('r') ? parseInt(urlParams.get('r'), 10) : 0;
    let intYear = urlParams.get('y') ? parseInt(urlParams.get('y'), 10) : 0;
    let brandId = urlParams.get('b') ? parseInt(urlParams.get('b'), 10) : 0;
    lstProject = showLinkParam ? [showLinkParam] : [];
    if (showLinkParam === '30003') {
        lstProject = ['30003', '30007'];
    }
    // if (showLinkParam === '0') {
    //   lstProject = ['30002', '30006'];
    //   intRstatus = 1;
    // } else if (showLinkParam === '1') {
    //   lstProject = ['30003', '30007'];
    // } else if (showLinkParam === '2') {
    //   lstProject = ['30002', '30006'];
    //   intRstatus = 2;
    // } else if (showLinkParam === '3') {
    //   lstProject = ['30005'];
    // }
    const [selPrjStatus, setSelPrjStatus] = useState(lstProject);
    const [intRiskStatus, setIntRiskStatus] = useState(intRstatus);
    const navigate = useNavigate();
    const boolScreenAccessCheck = ((_d = (_c = (_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.getClientUserScreenAccess) === null || _a === void 0 ? void 0 : _a.lstClientUserCompanies) === null || _b === void 0 ? void 0 : _b.find((obj) => { var _a, _b; return obj.intId === ((_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _a === void 0 ? void 0 : _a.userLoginDetails) === null || _b === void 0 ? void 0 : _b.intCompanyID); })) === null || _c === void 0 ? void 0 : _c.lstObjLuScreens) === null || _d === void 0 ? void 0 : _d.find((obj) => obj.intId === 2)) != undefined;
    useEffect(() => {
        var _a, _b, _c, _d, _e;
        if (!((_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.subscriptionDetails) === null || _a === void 0 ? void 0 : _a.boolProjectSearchProjectDetail) || !boolScreenAccessCheck) {
            navigate('/no-access');
            return;
        }
        else if ((_c = (_b = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _b === void 0 ? void 0 : _b.userLoginDetails) === null || _c === void 0 ? void 0 : _c.strUserEmailId) {
            commonService
                .logUserActivity((_e = (_d = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _d === void 0 ? void 0 : _d.userLoginDetails) === null || _e === void 0 ? void 0 : _e.strUserEmailId, UserActivity.CP__ProjectMgmt_Visited);
        }
        const firstPage = pagination.current == 1 ? pagination.current : ((pagination.current * 10) - 10) + 1;
        const lastPage = pagination.current == 1 ? pagination.pageSize : (pagination.current * 10);
        setIsLoading(true);
        setPrjDataList([]);
        const searchPrjReqObj = {
            intYear: intYear,
            objLuBrandName: {
                intId: brandId
            },
            lstClientMaster: getClientList(applicationData),
            intRiskStatus: intRiskStatus,
            boolProjectSearch: true,
            intProjectType: 1,
            boolClientSearch: true,
            strSearchBoxText: strSearchBoxText,
            lstLuProjectStatus: convertSelFilterValToLuObj(selPrjStatus),
            lstLuBrandName: convertSelFilterValToLuObj(selBrandList),
            objModuleFlags: { boolIsProjectSearch: true },
            lstobjBusinessUnit: convertSelFilterValBusinessToLuObj(selLstBVLocation),
            boolShowRenewedArtifacts: convertSelProjectType(selProjectType),
            dtProjPlannedStartDateFrom: formatDate(selRecommendedStartDate[0] ? selRecommendedStartDate[0].format('YYYY-MM-DD') : null),
            dtProjPlannedStartDateTo: formatDate(selRecommendedStartDate[1] ? selRecommendedStartDate[1].format('YYYY-MM-DD') : null),
            dtProjEstCompetionDateFrom: formatDate(selPlanedCompletionDate[0] ? selPlanedCompletionDate[0].format('YYYY-MM-DD') : null),
            dtProjEstCompetionDateTo: formatDate(selPlanedCompletionDate[1] ? selPlanedCompletionDate[1].format('YYYY-MM-DD') : null),
            dtProjActCompetionDateFrom: formatDate(selActualCompletionDate[0] ? selActualCompletionDate[0].format('YYYY-MM-DD') : null),
            dtProjActCompetionDateTo: formatDate(selActualCompletionDate[1] ? selActualCompletionDate[1].format('YYYY-MM-DD') : null),
            boolCardView: boolCardView,
            intPageSize: lastPage,
            intFirstPage: firstPage,
        };
        setPrjDataList([]);
        searchProjectsCount(searchPrjReqObj).then((res) => {
            setPagination(prev => (Object.assign(Object.assign({}, prev), { total: res })));
        });
        searchProjects(searchPrjReqObj).then((res) => {
            var _a, _b;
            setPrjDataList(res);
            setSearchPrjRequest(searchPrjReqObj);
            setIsLoading(false);
            commonService
                .logUserActivity((_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _a === void 0 ? void 0 : _a.userLoginDetails) === null || _b === void 0 ? void 0 : _b.strUserEmailId, UserActivity.CP__ProjectMgmt_Search);
        });
    }, [
        selPrjStatus,
        selBrandList,
        selCountryTerritoryList,
        selProductTypeList,
        selServiceTypeList,
        selLstBVLocation,
        selRecommendedStartDate,
        selPlanedCompletionDate,
        selActualCompletionDate,
        strSearchBoxText,
        selProjectType,
        boolCardView,
        intRiskStatus,
        pagination.current,
        pagination.pageSize
    ]);
    useEffect(() => {
        if (applicationData.keywordSearchStr) {
            handleClearAllAppliedFilters();
            setStrSearchBoxText(applicationData.keywordSearchStr);
            dispatch(setKeywordSearchStr(''));
        }
    }, [applicationData.keywordSearchStr]);
    const handleTableChange = (pagination) => {
        setPagination(prev => (Object.assign(Object.assign({}, prev), { current: pagination.current, pageSize: pagination.pageSize })));
    };
    const onChangeCardView = (e) => {
        setPrjDataList([]);
        setBoolCardView(e.target.checked);
    };
    const handleClearAllAppliedFilters = () => {
        setSelPrjStatus([]);
        setSelBrandList([]);
        setSelCountryTerritoryList([]);
        setSelProductTypeList([]);
        setSelServiceTypeList([]);
        setSelLstBVLocation([]);
        setSelRecommendedStartDate([undefined, undefined]);
        setSelPlanedCompletionDate([undefined, undefined]);
        setSelActualCompletionDate([undefined, undefined]);
        setSelProjectType([]);
        setStrSearchBoxText('');
        setIntRiskStatus(0);
        setPagination(prev => (Object.assign(Object.assign({}, prev), { current: 1 })));
    };
    useEffect(() => {
        setPagination(prev => (Object.assign(Object.assign({}, prev), { current: 1 })));
    }, [selPrjStatus,
        selBrandList,
        selLstBVLocation,
        selProjectType,
        selRecommendedStartDate,
        selPlanedCompletionDate,
        selActualCompletionDate,
        //boolCardView
    ]);
    const prjFilterSectionData = getPrjFilterSectionData(applicationData, selPrjStatus, (val) => setSelPrjStatus(val), selBrandList, (val) => setSelBrandList(val), selLstBVLocation, (val) => setSelLstBVLocation(val), selProjectType, (val) => setSelProjectType(val), selRecommendedStartDate, (val) => setSelRecommendedStartDate(val), selPlanedCompletionDate, (val) => setSelPlanedCompletionDate(val), selActualCompletionDate, (val) => setSelActualCompletionDate(val), handleClearAllAppliedFilters);
    const handleDelete = (projectId) => {
        setPrjDataList((prjDataList) => prjDataList === null || prjDataList === void 0 ? void 0 : prjDataList.filter((project) => project.strProjectId !== projectId));
    };
    const handlePageChange = (page) => {
        setCurrentPage(page);
    };
    const currentData = prjDataList === null || prjDataList === void 0 ? void 0 : prjDataList.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
    return (_jsxs(_Fragment, { children: [width <= 1150 &&
                _jsx(FloatingOptions, { data: prjFilterSectionData, extra: _jsx(Checkbox, { onChange: onChangeCardView, checked: boolCardView, children: "Show Card View" }) }), _jsxs(Row, { gutter: [16, 16], children: [width > 1150 &&
                        _jsx(Col, { xs: 24, sm: 24, md: 24, lg: 6, xl: 5, children: _jsx(FilterPanel, { data: prjFilterSectionData, extra: _jsx(Checkbox, { onChange: onChangeCardView, checked: boolCardView, children: "Show Card View" }) }) }), _jsx(Col, { xs: 24, sm: 24, md: 24, lg: 18, xl: 19, children: _jsx(Card, { style: { borderRadius: '0px' }, title: _jsxs(Typography.Text, { children: ["Project Search Result (Total Records: ", pagination.total, " )"] }), extra: _jsx(ProjectExcelDownload, { data: prjDataList, searchPrjRequest: searchPrjRequest, filename: 'Projects' }), children: boolCardView ? ((currentData === null || currentData === void 0 ? void 0 : currentData.length) ? (_jsxs(Row, { gutter: [16, 16], children: [currentData.map((data, index) => (_jsx(Col, { xs: 24, sm: 12, md: 12, lg: 12, xl: 12, children: _jsx(ProjectCard, { data: data, onDelete: handleDelete }, data.strProjectId) }, index))), _jsx(Col, { xs: 24, sm: 24, md: 24, lg: 24, xl: 24, children: _jsx(Pagination, { current: currentPage, pageSize: itemsPerPage, total: prjDataList === null || prjDataList === void 0 ? void 0 : prjDataList.length, onChange: handlePageChange }) })] })) : (_jsx(Row, { gutter: [16, 16], children: new Array(10).fill(0).map((_, index) => (_jsx(Col, { xs: 24, sm: 12, md: 12, lg: 12, xl: 12, children: _jsx(Card, { children: _jsx(Skeleton, { avatar: true, paragraph: { rows: 4 } }) }) }, index))) }))) : (_jsx(ProjectDataTable, { data: prjDataList, searchPrjRequest: searchPrjRequest, loading: isLoading, pagination: pagination, onChange: handleTableChange })) }) })] })] }));
};
export default Projects;
